import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import DisplayedWeiData from './DisplayedWeiData'
import DateComponent from './DateComponent'
import { Trans } from 'react-i18next';
import { Web3StatusContext } from "../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class WithdrawTokens extends React.Component {
  static contextType = Web3StatusContext;
  lastBlock = 0;

  state = { balanceDataKey: null,
    vestingReached: null,
    stackId: -1,
  };

  activeAccount = null;

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const balanceDataKey = contract.methods["balanceOf"].cacheCall(this.context.activeAccount);
  
    // save the `dataKey` to local component state for later reference
    this.setState({ balanceDataKey });

    contract.methods.vestingReached().call().then(function(result) {
      this.setState({vestingReached: result});
    }.bind(this));
  }

  componentDidUpdate() {
    if(this.lastBlock == this.context.blockNumber)
      return;

    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    contract.methods.vestingReached().call().then(function(result) {
      this.setState({vestingReached: result});
    }.bind(this));

    this.lastBlock = this.context.blockNumber;
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    const stackId = GAMEFORESTSale.methods.withdrawTokens.cacheSend(this.context.activeAccount);
    this.setState({ stackId: stackId });
  }

  render() {

    const { GAMEFORESTSale } = this.props.drizzleState.contracts;
    const balanceContract = GAMEFORESTSale["balanceOf"][this.state.balanceDataKey];

    var withdrawable = '0';
    var held = '0';

    var vestingDate = (<div><Trans>withdraw_tokens.can_withdraw</Trans><DateComponent drizzle={this.props.drizzle}
      drizzleState={this.props.drizzleState}
      dateName="getTime"
      getterParameter={4}>
    </DateComponent></div>);

    var disabled = false;
    if(this.state.vestingReached != null && balanceContract != undefined) {
      var balance = (<span><DisplayedWeiData
        drizzle={this.props.drizzle}
        drizzleState={this.props.drizzleState}
        contract="GAMEFORESTSale"
        method="balanceOf"
        methodArgs={[this.context.activeAccount]}
      />{" "}
      <ContractData
        drizzle={this.props.drizzle}
        drizzleState={this.props.drizzleState}
        contract="GAMEFOREST"
        method="symbol"
        hideIndicator
      /></span>);

      if(this.state.vestingReached) {
        withdrawable = balance;
        var balanceValue = this.context.web3.utils.fromWei(balanceContract.value, "ether");
        if(balanceValue == 0 || balanceContract.value == '0') {
          disabled = true;
        }
        vestingDate = '';
      }
      else {
        held = balance;
        disabled = true;
      }
    }

    var buttonCaption = this.context.i18n.t('withdraw_tokens.button_caption');

    return (
      <div>
        <h3><Trans>withdraw_tokens.withdraw_tokens</Trans></h3>
        <strong><Trans>withdraw_tokens.can_currently_withdraw</Trans>
          {withdrawable}</strong>
          <form onSubmit={this.mySubmitHandler}>
            <input
            type='submit'
            value={buttonCaption}
            disabled={disabled}
            />
          </form>
        <strong><Trans>withdraw_tokens.youhave_1</Trans>
          {held}
          <Trans>withdraw_tokens.youhave_2</Trans>
          {vestingDate}
          <br/><Trans>withdraw_tokens.please_withdraw</Trans>
        </strong>
      </div>
    );
  }
};

export default WithdrawTokens;